import React, { Component } from "react";
import { Col, Card, CardBody, CardHeader, Label, FormGroup } from "reactstrap";
import { APP_CONST, getStoredItem } from "../../../store/dataStore";

class Profile extends Component {
  state = {
    userInfo: JSON.parse(getStoredItem(APP_CONST.USER_INFO)),
  };

  genFormGroupWith = (title, desc) => {
    return (
      <FormGroup row>
        <Col md="3">
          <Label>
            <h6>{title}</h6>
          </Label>
        </Col>
        <Col xs="12" md="5">
          <Label>{desc}</Label>
        </Col>
      </FormGroup>
    );
  };

  render() {
    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>User's information</CardHeader>
          <CardBody>
            {this.genFormGroupWith(
              "User Roles:",
              [
                ...this.state.userInfo.userAccountDTO.authorities,
                ...this.state.userInfo.userAccountDTO.roles.map(r => r.name),
              ].join(", "),
            )}
            {this.genFormGroupWith(
              "User Name:",
              this.state.userInfo.userAccountDTO.login,
            )}
            {this.genFormGroupWith(
              "Full Name:",
              this.state.userInfo.userAccountDTO.firstName +
                " " +
                this.state.userInfo.userAccountDTO.lastName,
            )}
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default Profile;
